import { Styles } from 'react-modal'

const styles: Styles = {
  overlay: {
    zIndex: 99,
    backgroundColor: 'transparent',
  },
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    border: 'none',
    background: 'transparent',
    padding: '0',
    borderRadius: '0',
    color: 'var(--main-color)',
  },
}

export function useModalStyles(): { styles: Styles } {
  return {
    styles,
  }
}
